import {PagedData} from "@/services/models/shared/PagedData";
import {AxiosResponse} from "axios";
import {
    AdministrativeLocation,
    AdministrativeLocationFilterOptions,
    AdministrativeLocationListItem,
    NewAdministrativeLocation,
    UpdateAdministrativeLocation
} from "@/services/models/AdministrativeLocation";
import BimsHttpService from "@/services/BimsHttpService";

class AdministrativeLocationService {
    /**
     * @description Returns a paged list of administrative locations.
     */
    getAdministrativeLocationList(filter: AdministrativeLocationFilterOptions
    ): Promise<PagedData<AdministrativeLocationListItem>> {
        return BimsHttpService.get(`/administrativeLocations`, {
            params: filter
        }).then((response: AxiosResponse<PagedData<AdministrativeLocationListItem>>) => {
            return response.data as PagedData<AdministrativeLocationListItem>;
        });
    }

    /**
     * @description Returns the administrative location with the specified id
     */
    getAdministrativeLocation(id: number): Promise<AdministrativeLocation> {
        return BimsHttpService.get(`/administrativeLocations/${id}`).then((response: AxiosResponse<AdministrativeLocation>) => {
            return response.data as AdministrativeLocation;
        });
    }

    /**
     *  @description Adds a new administrative location
     */
    addAdministrativeLocation(administrativeLocation: NewAdministrativeLocation): Promise<any> {
        return BimsHttpService.post(`/administrativeLocations`,
            administrativeLocation
        );
    }

    /**
     * @description Updates the administrative location
     */
    updateAdministrativeLocation(administrativeLocation: UpdateAdministrativeLocation): Promise<any> {
        return BimsHttpService.put(`/administrativeLocations/${administrativeLocation.id}`,
            administrativeLocation
        )
    }

    /**
     * @description deletes the administrative location with the specified id
     */
    deleteAdministrativeLocation(id: number): Promise<any> {
        return BimsHttpService.delete(`/administrativeLocations/${id}`);
    }
}

export default new AdministrativeLocationService()
